module.exports = __webpack_public_path__ + "static/media/basketball.ee5f8da8.svg";